//@see https://kazupon.github.io/vue-i18n/guide/number.html
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
// https://www.iban.com/currency-codes
const defaultNumberFormat = {
    currency: {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }
}

export default {
    'de': defaultNumberFormat,
    'de-CH': {
        currency: {
            ...defaultNumberFormat.currency,
            currency: 'CHF'
        }
    },
    'en-GB': {
        currency: {
            ...defaultNumberFormat.currency,
            currency: 'GBP'
        }
    },
    'pl': {
        currency: {
            ...defaultNumberFormat.currency,
            currency: 'PLN'
        }
    },
    'fr': defaultNumberFormat,
    'fr-CH': {
        currency: {
            ...defaultNumberFormat.currency,
            currency: 'CHF'
        }
    },
    'cs': {
        currency: {
            ...defaultNumberFormat.currency,
            currency: 'CZK',
            groupSeparator: '.'
        }
    },
    'nl': defaultNumberFormat,
    'it': defaultNumberFormat,
    'pt': defaultNumberFormat,
    'es': defaultNumberFormat,
    'hu': {
        currency: {
            ...defaultNumberFormat.currency,
            currency: 'HUF'
        }
    },
    'sk': defaultNumberFormat,
    'ro': {
        currency: {
            ...defaultNumberFormat.currency,
            currency: 'RON',
            groupSeparator: '.'
        }
    }
}
